import { render, staticRenderFns } from "./compensation.vue?vue&type=template&id=503f39c3&scoped=true"
import script from "./compensation.vue?vue&type=script&lang=js"
export * from "./compensation.vue?vue&type=script&lang=js"
import style0 from "./compensation.vue?vue&type=style&index=0&id=503f39c3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503f39c3",
  null
  
)

export default component.exports